import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { buildUrl } from './util.build-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS
});
function getPageMetadata(portalId, pageId, options) {
  const url = buildUrl(
    `/api/v1/portals/${portalId}/pages/${pageId}/metadata`,
    options
  );
  return cache(!(options == null ? void 0 : options.disableCache) ? url : void 0, async () => {
    if (!pageId) {
      return {};
    }
    const response = await sitecoreAxios.get(url);
    return response.data;
  }).getStaleWhileRevalidate();
}

export { getPageMetadata };
//# sourceMappingURL=request.get-page-metadata.js.map
